import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const IconDottedLineLg1 = ({ className }) => (
  <svg className={classNames('dotted-line-lg-1 d-none d-lg-block position-absolute', className)} width="369" height="75" viewBox="0 0 369 75" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 8.5V23.5755C2 38.9454 9.42257 53.5344 21.7443 62.7216V62.7216C42.3957 78.1196 71.8234 74.7287 88.0745 54.7418V54.7418C97.2014 43.5167 110.899 37 125.366 37H148L193.677 32.0373C208.367 30.4413 222.5 25.5248 235.009 17.6599V17.6599C262.503 0.372814 296.803 -2.07606 326.474 11.1298L368 29.6119" stroke="#FDAE39" strokeWidth="4" strokeDasharray="2 2" />
  </svg>
);

IconDottedLineLg1.propTypes = {
  className: PropTypes.string,
};

IconDottedLineLg1.defaultProps = {
  className: '',
};
